var map = {
	"./achivement": 13,
	"./achivement.svg": 13,
	"./icons/absent-color-icon": 14,
	"./icons/absent-color-icon.svg": 14,
	"./icons/activity-icon": 15,
	"./icons/activity-icon.svg": 15,
	"./icons/arrow-down-icon": 16,
	"./icons/arrow-down-icon.svg": 16,
	"./icons/bell-icon": 17,
	"./icons/bell-icon.svg": 17,
	"./icons/book-icon": 18,
	"./icons/book-icon.svg": 18,
	"./icons/calendar-gray-icon": 19,
	"./icons/calendar-gray-icon.svg": 19,
	"./icons/calendar-icon": 20,
	"./icons/calendar-icon.svg": 20,
	"./icons/calendar-noti-icon": 21,
	"./icons/calendar-noti-icon.svg": 21,
	"./icons/campus-icon": 22,
	"./icons/campus-icon.svg": 22,
	"./icons/chevron-left-icon": 23,
	"./icons/chevron-left-icon.svg": 23,
	"./icons/chevron-right-icon": 24,
	"./icons/chevron-right-icon.svg": 24,
	"./icons/class-icon": 25,
	"./icons/class-icon.svg": 25,
	"./icons/clock-icon": 26,
	"./icons/clock-icon.svg": 26,
	"./icons/clock-solid-icon": 27,
	"./icons/clock-solid-icon.svg": 27,
	"./icons/close-icon": 28,
	"./icons/close-icon.svg": 28,
	"./icons/copy-icon": 29,
	"./icons/copy-icon.svg": 29,
	"./icons/correct-icon": 30,
	"./icons/correct-icon.svg": 30,
	"./icons/dot-icon": 31,
	"./icons/dot-icon.svg": 31,
	"./icons/douple-correct-icon": 32,
	"./icons/douple-correct-icon.svg": 32,
	"./icons/download-icon": 33,
	"./icons/download-icon.svg": 33,
	"./icons/dropdown-circle-icon": 34,
	"./icons/dropdown-circle-icon.svg": 34,
	"./icons/edit-icon": 35,
	"./icons/edit-icon.svg": 35,
	"./icons/eye-black-icon": 36,
	"./icons/eye-black-icon.svg": 36,
	"./icons/eye-icon": 37,
	"./icons/eye-icon.svg": 37,
	"./icons/eye-off-icon": 38,
	"./icons/eye-off-icon.svg": 38,
	"./icons/eye-regular-icon": 39,
	"./icons/eye-regular-icon.svg": 39,
	"./icons/hat-icon": 40,
	"./icons/hat-icon.svg": 40,
	"./icons/on-going-class-color-icon": 41,
	"./icons/on-going-class-color-icon.svg": 41,
	"./icons/people-group-gray-icon": 42,
	"./icons/people-group-gray-icon.svg": 42,
	"./icons/people-group-icon": 43,
	"./icons/people-group-icon.svg": 43,
	"./icons/present-color-icon": 44,
	"./icons/present-color-icon.svg": 44,
	"./icons/remove-icon": 45,
	"./icons/remove-icon.svg": 45,
	"./icons/replay-icon": 46,
	"./icons/replay-icon.svg": 46,
	"./icons/search-icon": 47,
	"./icons/search-icon.svg": 47,
	"./icons/student-icon": 48,
	"./icons/student-icon.svg": 48,
	"./icons/switch-icon": 49,
	"./icons/switch-icon.svg": 49,
	"./icons/teacher-icon": 50,
	"./icons/teacher-icon.svg": 50,
	"./icons/three-dot": 51,
	"./icons/three-dot-white-icon": 52,
	"./icons/three-dot-white-icon.svg": 52,
	"./icons/three-dot.svg": 51,
	"./icons/total-class-color-icon": 53,
	"./icons/total-class-color-icon.svg": 53,
	"./icons/vector-icon": 54,
	"./icons/vector-icon.svg": 54,
	"./login-background-1": 55,
	"./login-background-1.jpeg": 55,
	"./login-background-2": 56,
	"./login-background-2.jpeg": 56,
	"./logo-playsquad": 57,
	"./logo-playsquad.png": 57,
	"./qr-code": 58,
	"./qr-code.png": 58,
	"./shared/arrow-right": 59,
	"./shared/arrow-right.svg": 59,
	"./shared/avatar": 60,
	"./shared/avatar-default": 61,
	"./shared/avatar-default.png": 61,
	"./shared/avatar.svg": 60,
	"./shared/bank-logo": 62,
	"./shared/bank-logo.svg": 62,
	"./shared/bg-student": 63,
	"./shared/bg-student.svg": 63,
	"./shared/bg-teacher": 64,
	"./shared/bg-teacher.svg": 64,
	"./shared/class-display": 65,
	"./shared/class-display.svg": 65,
	"./shared/hat": 66,
	"./shared/hat.svg": 66,
	"./shared/people-group": 67,
	"./shared/people-group.svg": 67,
	"./shared/three-lines": 68,
	"./shared/three-lines.svg": 68,
	"./tabler-dark": 69,
	"./tabler-dark.svg": 69,
	"./tabler-light": 70,
	"./tabler-light.svg": 70,
	"./warning-sign": 71,
	"./warning-sign.svg": 71
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 104;